/** Active chapter's persistence policy for navigation that does not use links. */
let guard: (() => Promise<boolean>) | null = null;

export function registerEditorNavigationGuard(next: () => Promise<boolean>) {
    guard = next;
    return () => { if (guard === next) guard = null; };
}

export function prepareEditorNavigation(): Promise<boolean> {
    return guard?.() ?? Promise.resolve(true);
}
